//@ts-nocheck
import { Entry } from "./fixation";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
function createBaseQueryAllIndicesRequest() {
    return {
        storeKey: "",
        prefix: ""
    };
}
export const QueryAllIndicesRequest = {
    typeUrl: "/lavanet.lava.fixationstore.QueryAllIndicesRequest",
    is(o) {
        return o && (o.$typeUrl === QueryAllIndicesRequest.typeUrl || typeof o.storeKey === "string" && typeof o.prefix === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryAllIndicesRequest.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryAllIndicesRequest.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.storeKey !== "") {
            writer.uint32(10).string(message.storeKey);
        }
        if (message.prefix !== "") {
            writer.uint32(18).string(message.prefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllIndicesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.storeKey = reader.string();
                    break;
                case 2:
                    message.prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            storeKey: isSet(object.storeKey) ? String(object.storeKey) : "",
            prefix: isSet(object.prefix) ? String(object.prefix) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.storeKey !== undefined && (obj.storeKey = message.storeKey);
        message.prefix !== undefined && (obj.prefix = message.prefix);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllIndicesRequest();
        message.storeKey = object.storeKey ?? "";
        message.prefix = object.prefix ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllIndicesRequest();
        if (object.store_key !== undefined && object.store_key !== null) {
            message.storeKey = object.store_key;
        }
        if (object.prefix !== undefined && object.prefix !== null) {
            message.prefix = object.prefix;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.store_key = message.storeKey === "" ? undefined : message.storeKey;
        obj.prefix = message.prefix === "" ? undefined : message.prefix;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllIndicesRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllIndicesRequest.decode(message.value);
    },
    toProto(message) {
        return QueryAllIndicesRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryAllIndicesRequest",
            value: QueryAllIndicesRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllIndicesRequest.typeUrl, QueryAllIndicesRequest);
function createBaseQueryAllIndicesResponse() {
    return {
        indices: []
    };
}
export const QueryAllIndicesResponse = {
    typeUrl: "/lavanet.lava.fixationstore.QueryAllIndicesResponse",
    is(o) {
        return o && (o.$typeUrl === QueryAllIndicesResponse.typeUrl || Array.isArray(o.indices) && (!o.indices.length || typeof o.indices[0] === "string"));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryAllIndicesResponse.typeUrl || Array.isArray(o.indices) && (!o.indices.length || typeof o.indices[0] === "string"));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryAllIndicesResponse.typeUrl || Array.isArray(o.indices) && (!o.indices.length || typeof o.indices[0] === "string"));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.indices) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllIndicesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.indices.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            indices: Array.isArray(object?.indices) ? object.indices.map((e) => String(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.indices) {
            obj.indices = message.indices.map(e => e);
        }
        else {
            obj.indices = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllIndicesResponse();
        message.indices = object.indices?.map(e => e) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllIndicesResponse();
        message.indices = object.indices?.map(e => e) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.indices) {
            obj.indices = message.indices.map(e => e);
        }
        else {
            obj.indices = message.indices;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllIndicesResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllIndicesResponse.decode(message.value);
    },
    toProto(message) {
        return QueryAllIndicesResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryAllIndicesResponse",
            value: QueryAllIndicesResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllIndicesResponse.typeUrl, QueryAllIndicesResponse);
function createBaseQueryStoreKeysRequest() {
    return {};
}
export const QueryStoreKeysRequest = {
    typeUrl: "/lavanet.lava.fixationstore.QueryStoreKeysRequest",
    is(o) {
        return o && o.$typeUrl === QueryStoreKeysRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryStoreKeysRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryStoreKeysRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryStoreKeysRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryStoreKeysRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryStoreKeysRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryStoreKeysRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryStoreKeysRequest.decode(message.value);
    },
    toProto(message) {
        return QueryStoreKeysRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryStoreKeysRequest",
            value: QueryStoreKeysRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryStoreKeysRequest.typeUrl, QueryStoreKeysRequest);
function createBaseStoreKeyAndPrefix() {
    return {
        storeKey: "",
        prefix: ""
    };
}
export const StoreKeyAndPrefix = {
    typeUrl: "/lavanet.lava.fixationstore.StoreKeyAndPrefix",
    is(o) {
        return o && (o.$typeUrl === StoreKeyAndPrefix.typeUrl || typeof o.storeKey === "string" && typeof o.prefix === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === StoreKeyAndPrefix.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === StoreKeyAndPrefix.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.storeKey !== "") {
            writer.uint32(10).string(message.storeKey);
        }
        if (message.prefix !== "") {
            writer.uint32(18).string(message.prefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoreKeyAndPrefix();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.storeKey = reader.string();
                    break;
                case 2:
                    message.prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            storeKey: isSet(object.storeKey) ? String(object.storeKey) : "",
            prefix: isSet(object.prefix) ? String(object.prefix) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.storeKey !== undefined && (obj.storeKey = message.storeKey);
        message.prefix !== undefined && (obj.prefix = message.prefix);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseStoreKeyAndPrefix();
        message.storeKey = object.storeKey ?? "";
        message.prefix = object.prefix ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseStoreKeyAndPrefix();
        if (object.store_key !== undefined && object.store_key !== null) {
            message.storeKey = object.store_key;
        }
        if (object.prefix !== undefined && object.prefix !== null) {
            message.prefix = object.prefix;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.store_key = message.storeKey === "" ? undefined : message.storeKey;
        obj.prefix = message.prefix === "" ? undefined : message.prefix;
        return obj;
    },
    fromAminoMsg(object) {
        return StoreKeyAndPrefix.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return StoreKeyAndPrefix.decode(message.value);
    },
    toProto(message) {
        return StoreKeyAndPrefix.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.StoreKeyAndPrefix",
            value: StoreKeyAndPrefix.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(StoreKeyAndPrefix.typeUrl, StoreKeyAndPrefix);
function createBaseQueryStoreKeysResponse() {
    return {
        keys: []
    };
}
export const QueryStoreKeysResponse = {
    typeUrl: "/lavanet.lava.fixationstore.QueryStoreKeysResponse",
    is(o) {
        return o && (o.$typeUrl === QueryStoreKeysResponse.typeUrl || Array.isArray(o.keys) && (!o.keys.length || StoreKeyAndPrefix.is(o.keys[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryStoreKeysResponse.typeUrl || Array.isArray(o.keys) && (!o.keys.length || StoreKeyAndPrefix.isSDK(o.keys[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryStoreKeysResponse.typeUrl || Array.isArray(o.keys) && (!o.keys.length || StoreKeyAndPrefix.isAmino(o.keys[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.keys) {
            StoreKeyAndPrefix.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryStoreKeysResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keys.push(StoreKeyAndPrefix.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            keys: Array.isArray(object?.keys) ? object.keys.map((e) => StoreKeyAndPrefix.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.keys) {
            obj.keys = message.keys.map(e => e ? StoreKeyAndPrefix.toJSON(e) : undefined);
        }
        else {
            obj.keys = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryStoreKeysResponse();
        message.keys = object.keys?.map(e => StoreKeyAndPrefix.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryStoreKeysResponse();
        message.keys = object.keys?.map(e => StoreKeyAndPrefix.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.keys) {
            obj.keys = message.keys.map(e => e ? StoreKeyAndPrefix.toAmino(e) : undefined);
        }
        else {
            obj.keys = message.keys;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryStoreKeysResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryStoreKeysResponse.decode(message.value);
    },
    toProto(message) {
        return QueryStoreKeysResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryStoreKeysResponse",
            value: QueryStoreKeysResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryStoreKeysResponse.typeUrl, QueryStoreKeysResponse);
function createBaseQueryVersionsRequest() {
    return {
        storeKey: "",
        prefix: "",
        key: ""
    };
}
export const QueryVersionsRequest = {
    typeUrl: "/lavanet.lava.fixationstore.QueryVersionsRequest",
    is(o) {
        return o && (o.$typeUrl === QueryVersionsRequest.typeUrl || typeof o.storeKey === "string" && typeof o.prefix === "string" && typeof o.key === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryVersionsRequest.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string" && typeof o.key === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryVersionsRequest.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string" && typeof o.key === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.storeKey !== "") {
            writer.uint32(10).string(message.storeKey);
        }
        if (message.prefix !== "") {
            writer.uint32(18).string(message.prefix);
        }
        if (message.key !== "") {
            writer.uint32(26).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVersionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.storeKey = reader.string();
                    break;
                case 2:
                    message.prefix = reader.string();
                    break;
                case 3:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            storeKey: isSet(object.storeKey) ? String(object.storeKey) : "",
            prefix: isSet(object.prefix) ? String(object.prefix) : "",
            key: isSet(object.key) ? String(object.key) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.storeKey !== undefined && (obj.storeKey = message.storeKey);
        message.prefix !== undefined && (obj.prefix = message.prefix);
        message.key !== undefined && (obj.key = message.key);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVersionsRequest();
        message.storeKey = object.storeKey ?? "";
        message.prefix = object.prefix ?? "";
        message.key = object.key ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryVersionsRequest();
        if (object.store_key !== undefined && object.store_key !== null) {
            message.storeKey = object.store_key;
        }
        if (object.prefix !== undefined && object.prefix !== null) {
            message.prefix = object.prefix;
        }
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.store_key = message.storeKey === "" ? undefined : message.storeKey;
        obj.prefix = message.prefix === "" ? undefined : message.prefix;
        obj.key = message.key === "" ? undefined : message.key;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryVersionsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryVersionsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryVersionsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryVersionsRequest",
            value: QueryVersionsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryVersionsRequest.typeUrl, QueryVersionsRequest);
function createBaseQueryVersionsResponse() {
    return {
        entries: []
    };
}
export const QueryVersionsResponse = {
    typeUrl: "/lavanet.lava.fixationstore.QueryVersionsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryVersionsResponse.typeUrl || Array.isArray(o.entries) && (!o.entries.length || Entry.is(o.entries[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryVersionsResponse.typeUrl || Array.isArray(o.entries) && (!o.entries.length || Entry.isSDK(o.entries[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryVersionsResponse.typeUrl || Array.isArray(o.entries) && (!o.entries.length || Entry.isAmino(o.entries[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.entries) {
            Entry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVersionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(Entry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e) => Entry.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map(e => e ? Entry.toJSON(e) : undefined);
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVersionsResponse();
        message.entries = object.entries?.map(e => Entry.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryVersionsResponse();
        message.entries = object.entries?.map(e => Entry.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map(e => e ? Entry.toAmino(e) : undefined);
        }
        else {
            obj.entries = message.entries;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryVersionsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryVersionsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryVersionsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryVersionsResponse",
            value: QueryVersionsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryVersionsResponse.typeUrl, QueryVersionsResponse);
function createBaseQueryEntryRequest() {
    return {
        storeKey: "",
        prefix: "",
        key: "",
        block: BigInt(0),
        hideData: false,
        stringData: false
    };
}
export const QueryEntryRequest = {
    typeUrl: "/lavanet.lava.fixationstore.QueryEntryRequest",
    is(o) {
        return o && (o.$typeUrl === QueryEntryRequest.typeUrl || typeof o.storeKey === "string" && typeof o.prefix === "string" && typeof o.key === "string" && typeof o.block === "bigint" && typeof o.hideData === "boolean" && typeof o.stringData === "boolean");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEntryRequest.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string" && typeof o.key === "string" && typeof o.block === "bigint" && typeof o.hide_data === "boolean" && typeof o.string_data === "boolean");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEntryRequest.typeUrl || typeof o.store_key === "string" && typeof o.prefix === "string" && typeof o.key === "string" && typeof o.block === "bigint" && typeof o.hide_data === "boolean" && typeof o.string_data === "boolean");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.storeKey !== "") {
            writer.uint32(10).string(message.storeKey);
        }
        if (message.prefix !== "") {
            writer.uint32(18).string(message.prefix);
        }
        if (message.key !== "") {
            writer.uint32(26).string(message.key);
        }
        if (message.block !== BigInt(0)) {
            writer.uint32(32).uint64(message.block);
        }
        if (message.hideData === true) {
            writer.uint32(40).bool(message.hideData);
        }
        if (message.stringData === true) {
            writer.uint32(48).bool(message.stringData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEntryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.storeKey = reader.string();
                    break;
                case 2:
                    message.prefix = reader.string();
                    break;
                case 3:
                    message.key = reader.string();
                    break;
                case 4:
                    message.block = reader.uint64();
                    break;
                case 5:
                    message.hideData = reader.bool();
                    break;
                case 6:
                    message.stringData = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            storeKey: isSet(object.storeKey) ? String(object.storeKey) : "",
            prefix: isSet(object.prefix) ? String(object.prefix) : "",
            key: isSet(object.key) ? String(object.key) : "",
            block: isSet(object.block) ? BigInt(object.block.toString()) : BigInt(0),
            hideData: isSet(object.hideData) ? Boolean(object.hideData) : false,
            stringData: isSet(object.stringData) ? Boolean(object.stringData) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.storeKey !== undefined && (obj.storeKey = message.storeKey);
        message.prefix !== undefined && (obj.prefix = message.prefix);
        message.key !== undefined && (obj.key = message.key);
        message.block !== undefined && (obj.block = (message.block || BigInt(0)).toString());
        message.hideData !== undefined && (obj.hideData = message.hideData);
        message.stringData !== undefined && (obj.stringData = message.stringData);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEntryRequest();
        message.storeKey = object.storeKey ?? "";
        message.prefix = object.prefix ?? "";
        message.key = object.key ?? "";
        message.block = object.block !== undefined && object.block !== null ? BigInt(object.block.toString()) : BigInt(0);
        message.hideData = object.hideData ?? false;
        message.stringData = object.stringData ?? false;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEntryRequest();
        if (object.store_key !== undefined && object.store_key !== null) {
            message.storeKey = object.store_key;
        }
        if (object.prefix !== undefined && object.prefix !== null) {
            message.prefix = object.prefix;
        }
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        if (object.block !== undefined && object.block !== null) {
            message.block = BigInt(object.block);
        }
        if (object.hide_data !== undefined && object.hide_data !== null) {
            message.hideData = object.hide_data;
        }
        if (object.string_data !== undefined && object.string_data !== null) {
            message.stringData = object.string_data;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.store_key = message.storeKey === "" ? undefined : message.storeKey;
        obj.prefix = message.prefix === "" ? undefined : message.prefix;
        obj.key = message.key === "" ? undefined : message.key;
        obj.block = message.block !== BigInt(0) ? (message.block?.toString)() : undefined;
        obj.hide_data = message.hideData === false ? undefined : message.hideData;
        obj.string_data = message.stringData === false ? undefined : message.stringData;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEntryRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEntryRequest.decode(message.value);
    },
    toProto(message) {
        return QueryEntryRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryEntryRequest",
            value: QueryEntryRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEntryRequest.typeUrl, QueryEntryRequest);
function createBaseQueryEntryResponse() {
    return {
        entry: undefined,
        stringData: ""
    };
}
export const QueryEntryResponse = {
    typeUrl: "/lavanet.lava.fixationstore.QueryEntryResponse",
    is(o) {
        return o && (o.$typeUrl === QueryEntryResponse.typeUrl || typeof o.stringData === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEntryResponse.typeUrl || typeof o.string_data === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEntryResponse.typeUrl || typeof o.string_data === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.entry !== undefined) {
            Entry.encode(message.entry, writer.uint32(10).fork()).ldelim();
        }
        if (message.stringData !== "") {
            writer.uint32(18).string(message.stringData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEntryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entry = Entry.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.stringData = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entry: isSet(object.entry) ? Entry.fromJSON(object.entry) : undefined,
            stringData: isSet(object.stringData) ? String(object.stringData) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.entry !== undefined && (obj.entry = message.entry ? Entry.toJSON(message.entry) : undefined);
        message.stringData !== undefined && (obj.stringData = message.stringData);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEntryResponse();
        message.entry = object.entry !== undefined && object.entry !== null ? Entry.fromPartial(object.entry) : undefined;
        message.stringData = object.stringData ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEntryResponse();
        if (object.entry !== undefined && object.entry !== null) {
            message.entry = Entry.fromAmino(object.entry);
        }
        if (object.string_data !== undefined && object.string_data !== null) {
            message.stringData = object.string_data;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.entry = message.entry ? Entry.toAmino(message.entry) : undefined;
        obj.string_data = message.stringData === "" ? undefined : message.stringData;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEntryResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEntryResponse.decode(message.value);
    },
    toProto(message) {
        return QueryEntryResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.fixationstore.QueryEntryResponse",
            value: QueryEntryResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEntryResponse.typeUrl, QueryEntryResponse);
